const waConfig = {
  pageview: {
    reports: '/cotizador-black/relatorios',
    operations: '/cotizador-black/operacoes/{{category}}',
    customQuotes: '/cotizador-black/cotacao-personalizada',
    createOperation: '/cotizador-black/monte-sua-operacao',
    proposalCenter: '/cotizador-black/central-de-propostas',
    product: '/cotizador-black/operacao/{{assetName/productId}}',
    acquisitionSuccess: '/cotizador-black/proposta/envio/sucesso',
    createOperationSuccess: '/cotizador-black/monte-sua-operacao/sucesso',
    acquisition: '/cotizador-black/proposta/envio/{{assetName/productId}}',
    proposalCenterViewPush: '/cotizador-black/central-de-propostas/visualizar-push'
  },
  event: {
    customQuotes: {
      edit: 'cotizador black;cotações personalizadas;editar',
      save: 'cotizador black;cotações personalizadas;salvar',
      quote: 'cotizador black;cotações personalizadas;cotar',
      copy: 'cotizador black;cotações personalizadas;copiar',
      delete: 'cotizador black;cotações personalizadas;deletar',
      clear: 'cotizador black;cotações personalizadas;limpar cotação',
      startQuote: 'cotizador black;cotações personalizadas;iniciar cotação',
    },
    menu: 'cotizador black;menu;{{menu}}',
    operations: {
      category: 'cotizador black;operações disponíveis - categoria;{{categoryName}}',
      seeDetails: 'cotizador black;operações disponíveis;ver detalhes',
      orderBy: 'cotizador black;operações disponíveis - ordenado por;{{orderBy}}',
      orderAsc: 'cotizador black;operações disponíveis - ordenação;{{orderAsc}}',
    },
    reports: {
      download: 'cotizador black;baixar relatório;{{reportName}}',
    },
    createOperation: {
      delete:'cotizador black;monte sua operação;excluir',
      buttonSaveOperation:'cotizador black;monte sua operação;salvar',
      buttonCreateOperation:'cotizador black;personalize sua operação;montar operação'
    },
    cmsModal: {
      buttonAcceptTerm: 'cotizador black;operacao;aceitar termo de operação sob custódia',
    },
    product: {
      export:'cotizador black;operacao;exportar',
      buttonSendProposals:'cotizador black;operacao;enviar propostas'
    },
    acquisition: {
      buttonSendPush:'cotizador black;proposta;enviar push',
      verifyRisk:'cotizador black;proposta;validar risco',
      importBaskClients:'cotizador black;proposta;importar bask clientes',
    },
    proposalCenter: {
      exportPush:'cotizador black;central de propostas;exportar push',
      seePush:'cotizador black;central de propostas;ver push',
      reload:'cotizador black;central de propostas;recarregar',
      export:'cotizador black;central de propostas;exportar',
    },
  },
};

export const waDataReplace = (string, value) => (
  string.replace(/[{]{2}(.+?)[}]{2}/g, value)
);

export default waConfig;
